import { useTranslation } from "react-i18next"

const NotFound = () => {
  const { t } = useTranslation()

  return (
    <div className="text-center mt-10">
      <h1 className="text-2xl">{t("error.page_not_found", "This page cannot be found")}</h1>
      <p>
        {t("error.contact_administrator", "If you believe this is an error, please contact your event administrator.")}
      </p>
    </div>
  )
}

NotFound.displayName = "NotFound"

export { NotFound }
